export default "__VITE_ASSET__DzzHZYd0__"